import { render, staticRenderFns } from "./SolutionTypeDetail.vue?vue&type=template&id=6d4aaf90&scoped=true&"
import script from "./SolutionTypeDetail.vue?vue&type=script&lang=js&"
export * from "./SolutionTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4aaf90",
  null
  
)

export default component.exports